import { Toaster } from "sonner";

export function ToastPortal() {
  return <Toaster richColors position="top-right" />;
}
